// The wind speed reading is an unsigned 12-bit integer-with-multiplier value indicating the average time between pulses. This value is first converted to frequency and then converted to wind speed in meters per second (m/s). The ConversionFormulaScale and ConversionFormulaOffset parameters are used to convert frequency to wind speed. Convert the 12-bit value ($rdg in code below) to wind speed ($spd in code below) using the following algorithm:
// $spd = 0.0;

/*
if ( $rdg == 0xFFF ) {
  $spd = null; // display reading as “invalid”
} else {
  $scale = 0.0;

  $cnt = ((int)$rdg) >> 2;
  $mult =  ((int)$rdg) & 0x03;

  switch ( $mult ) {
    case 0: $scale = 0.1E-3; break;
    case 1: $scale = 0.4E-3; break;
    case 2: $scale = 1.6E-3; break;
    case 3: $scale = 6.4E-3; break;
  }

  $dt = ($cnt * $scale);
  if ($dt > 0.0) {
    $kfactor = (float)$ConversionFormulaScale;
    $offset = (float)$ConversionFormulaOffset;
    $freq = 1.0 / $dt;
    $val = $offset + ($kfactor * $freq);
    // only allow values greater than the offset value, or 0

    if ( $val > $offset ) {
      $spd = $val;
    }
  }
}
*/

// export function windSpeed(
//   reading: number,
//   scale: number,
//   offset: number,
//   frequency: number
// ): number {
//   const count = reading >> 2
//   const multiplier = reading & 0x03
//   const scaler = [0.1e-3, 0.4e-3, 1.6e-3, 6.4e-3][multiplier]

//   const dt = count * scaler

//   if (dt > 0.0) {
//     const kfactor = scaler
//     const freq = 1.0 / dt
//     const value = offset + kfactor * freq

//     // only allow values greater than the offset value, or 0
//     if (value > offset) {
//       return value
//     }
//   }

//   return 0.0
// }

//   /************************************************************************************************
//    *
//    ************************************************************************************************/
//     private function CR_WSWindSpeed(
//     $did,
//     $sid,
//     $dms,
//     $lid,
//     $sts,
//     $dev,
//     $rdg,
//     $cfg
// ) {
//     // this code is based on GenericPaddleWheel
//     $valf = 0.0;
//     $type = DBManager::DB_SNSRDG_WSWindSpeed;
//     $ucat = DBManager::DB_UCAT_Velocity;

//     if ($rdg == 0xfff) {
//         $valf = null;
//     } else {
//         $scale = 0.0;

//         $cnt = ((int) $rdg) >> 2;
//         $mult = ((int) $rdg) & 0x03;

//         switch ($mult) {
//             case 0:
//                 $scale = 0.1e-3;
//                 break;
//             case 1:
//                 $scale = 0.4e-3;
//                 break;
//             case 2:
//                 $scale = 1.6e-3;
//                 break;
//             case 3:
//                 $scale = 6.4e-3;
//                 break;
//         }

//         $dt = $cnt * $scale;
//         if ($dt > 0.0) {
//             $kfactor = (float) $cfg["CNVRSN_SCALE"];
//             $offset = (float) $cfg["CNVRSN_OFFSET"];
//             $freq = 1.0 / $dt;
//             $vel = $kfactor * $freq + $offset;
//             if ($vel > 0.0 && $vel > $offset) {
//                 // minimum value is the offset
//                 $valf = $vel;
//             }
//         }
//     }

//     $this->InsertSensorReading($lid, $sid, $type, $valf, $ucat);

//     return;
// }

export function windSpeed(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  let windSpeed = 0.0

  const count = reading >> 2
  const multiplier = reading & 0x03
  const k = [0.1e-3, 0.4e-3, 1.6e-3, 6.4e-3][multiplier] || 0.0

  const time = count * k

  if (time > 0.0) {
    // const freq = 1.0 / time
    windSpeed = scale / time + offset
  }

  if (windSpeed > 0.0 && windSpeed > offset) {
    return windSpeed
  }

  return 0.0
}
